<template> 
  <div class="router-front"></div>
  <div class="router">
  
  <router-view v-slot="{ Component, route }">
  <transition name="fade" mode="out-in">
    <component :is="Component" :key="route.path" />
  </transition>
</router-view>
  </div> 
  <div  class="router-backend"></div>
  </template>
  <script setup>
  import {reactive,provide,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
  import * as vueUse from "@vueuse/core";
  import Language from "@/hooks/language.js";
  import Router from "@/hooks/router.js";
  import bridge from "@/utils/sdkBridge.js";
  import * as request from "@/api/request";
  import * as utils from "@/utils";
  import * as _ from "lodash-es";
  import { useRoute } from 'vue-router';
 

 const route = useRoute();
      const { initLang ,curLang, getLangTxt, langData} = Language();

      const routerData = {};
      const compData = {};
      const PAGE_DATA_LANG = {"default":{"isLogin":true,"host":utils.getMainHost(),"pageId":"mupc0331","loginAccount":"jiayaner","isBind":true,"serverName":"S1 超级厉害服","roleName":"超级厉害角色","signTime":2,"lotteryTime":3,"couponCount":50,"money":"250","infoPopupState":false,"bindPopupState":false,"bagPopupState":false,"myPackageList":[{award_time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"tipsPopupState":false,"propsPopupState":false,"curGiftPic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074115524.png","quanPopupState":false,"tips":"提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"firstPayType":"sendVt","firstPayState":0,"gameId":390,"pageName":"精灵盛典欧美版PC端推广活动","uid":``,"lotteryType":"no_reset","curGiftName":"一个神奇的大礼包","seeGiftPopupState":false,"seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"payEnough":false,"giftCodePopupState":false,"recentServerList":[],"quanUseLink":`https://www.37games.com`,"storeLink":`https://pay.37games.com/platform/officialWebStore.html?gameId=390`,"exchangeLink":`https://gevents.37games.com/globalexchange/index.html?gameId=390`,"common-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887915986-95.png`,"isEdit":true,"canReBind":false,"ten-lottery-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735786792708-42.png`,"titleIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887915965-18.png`,"bgColor":`#240d16`,"btnColor":`#40161f`,"titleColor1":`#fdf89b`,"titleColor2":`#ee6d37`,"borderColor":`#8b5b64`,"giftCardPopupState":``,"giftCardNumber":`DSFK OEMD NDJE`,"giftCardPassword":`09823857825755`,"activityType":``,"isBrandType":false,"thanksPopupState":``,"isAllowLottery":true,"disable-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735183017145-84.png`,"multiAwardIconList":[['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png'],['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png'],],"multiAwardPopupState":false,"isPadding":true,"dotHighLightColor":`#fff005`,"previewPopup":``,"taskAwardToast":false,"taskAwardList":[],"initFinished":false,"inGame":false,"shareFactoryInst":null,"shareAppKey":``,"shareAppId":``,"shareTitle":``,"shareContent":``,"shareImage":``,"shareChannel":[{"channel":""}],"downloadGameLink":``,"popupBg":``,"isActivityEnd":false,"taskRewardPopupState":false,"pcClientLink":``,"onelink":``},"en-US":{"isLogin":true,"host":utils.getMainHost(),"pageId":"mupc0331","loginAccount":"jiayaner","isBind":true,"serverName":"S1 超级厉害服","roleName":"超级厉害角色","signTime":2,"lotteryTime":3,"couponCount":50,"money":"250","infoPopupState":false,"bindPopupState":false,"bagPopupState":false,"myPackageList":[{award_time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"tipsPopupState":false,"propsPopupState":false,"curGiftPic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074115524.png","quanPopupState":false,"tips":"提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"firstPayType":"sendVt","firstPayState":0,"gameId":390,"pageName":"精灵盛典欧美版PC端推广活动","uid":``,"lotteryType":"no_reset","curGiftName":"一个神奇的大礼包","seeGiftPopupState":false,"seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"payEnough":false,"giftCodePopupState":false,"recentServerList":[],"quanUseLink":`https://www.37games.com`,"storeLink":`https://pay.37games.com/platform/officialWebStore.html?gameId=390`,"exchangeLink":`https://gevents.37games.com/globalexchange/index.html?gameId=390`,"common-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887915986-95.png`,"isEdit":true,"canReBind":false,"ten-lottery-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735786792708-42.png`,"titleIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887915965-18.png`,"bgColor":`#240d16`,"btnColor":`#40161f`,"titleColor1":`#fdf89b`,"titleColor2":`#ee6d37`,"borderColor":`#8b5b64`,"giftCardPopupState":``,"giftCardNumber":`DSFK OEMD NDJE`,"giftCardPassword":`09823857825755`,"activityType":``,"isBrandType":false,"thanksPopupState":``,"isAllowLottery":true,"disable-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735183017145-84.png`,"multiAwardIconList":[['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png'],['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png'],],"multiAwardPopupState":false,"isPadding":true,"dotHighLightColor":`#fff005`,"previewPopup":``,"taskAwardToast":false,"taskAwardList":[],"initFinished":false,"inGame":false,"shareFactoryInst":null,"shareAppKey":``,"shareAppId":``,"shareTitle":`Champion's Return`,"shareContent":`Champion's Return`,"shareImage":``,"shareChannel":[{"channel":""}],"downloadGameLink":``,"popupBg":``,"isActivityEnd":false,"taskRewardPopupState":false,"pcClientLink":`https://gevents.37games.com/exe/muglo/MU Dark Epoch_downloader_install.exe`,"onelink":`https://muus.onelink.me/JOgw/20erv3op`},"th-TH":{"isLogin":true,"host":utils.getMainHost(),"pageId":"mupc0331","loginAccount":"jiayaner","isBind":true,"serverName":"S1 超级厉害服","roleName":"超级厉害角色","signTime":2,"lotteryTime":3,"couponCount":50,"money":"250","infoPopupState":false,"bindPopupState":false,"bagPopupState":false,"myPackageList":[{award_time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"tipsPopupState":false,"propsPopupState":false,"curGiftPic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074115524.png","quanPopupState":false,"tips":"提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"firstPayType":"sendVt","firstPayState":0,"gameId":390,"pageName":"精灵盛典欧美版PC端推广活动","uid":``,"lotteryType":"no_reset","curGiftName":"一个神奇的大礼包","seeGiftPopupState":false,"seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"payEnough":false,"giftCodePopupState":false,"recentServerList":[],"quanUseLink":`https://www.37games.com`,"storeLink":`https://pay.37games.com/platform/officialWebStore.html?gameId=390`,"exchangeLink":`https://gevents.37games.com/globalexchange/index.html?gameId=390`,"common-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887915986-95.png`,"isEdit":true,"canReBind":false,"ten-lottery-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735786792708-42.png`,"titleIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887915965-18.png`,"bgColor":`#240d16`,"btnColor":`#40161f`,"titleColor1":`#fdf89b`,"titleColor2":`#ee6d37`,"borderColor":`#8b5b64`,"giftCardPopupState":``,"giftCardNumber":`DSFK OEMD NDJE`,"giftCardPassword":`09823857825755`,"activityType":``,"isBrandType":false,"thanksPopupState":``,"isAllowLottery":true,"disable-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735183017145-84.png`,"multiAwardIconList":[['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png'],['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png'],],"multiAwardPopupState":false,"isPadding":true,"dotHighLightColor":`#fff005`,"previewPopup":``,"taskAwardToast":false,"taskAwardList":[],"initFinished":false,"inGame":false,"shareFactoryInst":null,"shareAppKey":``,"shareAppId":``,"shareTitle":`ผู้กล้าหวนคืน`,"shareContent":`ผู้กล้าหวนคืน`,"shareImage":``,"shareChannel":[{"channel":""}],"downloadGameLink":``,"popupBg":``,"isActivityEnd":false,"taskRewardPopupState":false,"pcClientLink":`https://gevents.37games.com/exe/muglo/MU Dark Epoch_downloader_install.exe`,"onelink":`https://muus.onelink.me/JOgw/20erv3op`},"ru-RU":{"isLogin":true,"host":utils.getMainHost(),"pageId":"mupc0331","loginAccount":"jiayaner","isBind":true,"serverName":"S1 超级厉害服","roleName":"超级厉害角色","signTime":2,"lotteryTime":3,"couponCount":50,"money":"250","infoPopupState":false,"bindPopupState":false,"bagPopupState":false,"myPackageList":[{award_time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"tipsPopupState":false,"propsPopupState":false,"curGiftPic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074115524.png","quanPopupState":false,"tips":"提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"firstPayType":"sendVt","firstPayState":0,"gameId":390,"pageName":"精灵盛典欧美版PC端推广活动","uid":``,"lotteryType":"no_reset","curGiftName":"一个神奇的大礼包","seeGiftPopupState":false,"seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"payEnough":false,"giftCodePopupState":false,"recentServerList":[],"quanUseLink":`https://www.37games.com`,"storeLink":`https://pay.37games.com/platform/officialWebStore.html?gameId=390`,"exchangeLink":`https://gevents.37games.com/globalexchange/index.html?gameId=390`,"common-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887915986-95.png`,"isEdit":true,"canReBind":false,"ten-lottery-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735786792708-42.png`,"titleIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887915965-18.png`,"bgColor":`#240d16`,"btnColor":`#40161f`,"titleColor1":`#fdf89b`,"titleColor2":`#ee6d37`,"borderColor":`#8b5b64`,"giftCardPopupState":``,"giftCardNumber":`DSFK OEMD NDJE`,"giftCardPassword":`09823857825755`,"activityType":``,"isBrandType":false,"thanksPopupState":``,"isAllowLottery":true,"disable-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735183017145-84.png`,"multiAwardIconList":[['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png'],['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png','https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412783-39.png'],],"multiAwardPopupState":false,"isPadding":true,"dotHighLightColor":`#fff005`,"previewPopup":``,"taskAwardToast":false,"taskAwardList":[],"initFinished":false,"inGame":false,"shareFactoryInst":null,"shareAppKey":``,"shareAppId":``,"shareTitle":`Возвращение чемпиона`,"shareContent":`Возвращение чемпиона`,"shareImage":``,"shareChannel":[{"channel":""}],"downloadGameLink":``,"popupBg":``,"isActivityEnd":false,"taskRewardPopupState":false,"pcClientLink":`https://gevents.37games.com/exe/muglo/MU Dark Epoch_downloader_install.exe`,"onelink":`https://musru.onelink.me/eccd/5h9hpghp
`}};
      const pageData = reactive(PAGE_DATA_LANG[curLang] || PAGE_DATA_LANG['en-US']||{});
      let pagePlatform = "global"
      let pagePlatformId = 8;

      provide("pageData", pageData);

      if(pageData.gameId!==void 0 ){
        pageData.gameId = utils.getUrlParams("gameId") ||  utils.getUrlParams("gameID") ||  utils.getUrlParams("game_id") || pageData.gameId || ""
      }

      initLang();
      // 自定义setup - 开始
      const router = Router()

// 如果是模版，就修改一个能用的活动标识
if (/^template/.test(pageData.pageId)) {
  pageData.pageId = "lotteryvn"
}

if (window.innerWidth < window.innerHeight && router.hasRoute("m")) {
  router.gotoRouter("/m")
}

window.activityDataLayer.push({
  eventName: "view_page",
  eventType: pageData.pageName,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
// 记录礼包名
const giftInfo = reactive({
  firstPayAward: [],
  signInAward: [],
  lotteryAward: [],
  exchangeAward: [],
  taskAward: [],
  taskListAward: []
})

const curPlatform = pagePlatform;

const defaultServerItem = [
  {
    sid: "",
    id: "",
    sname: getLangTxt("pleaseSelectServer")
  },
]
const defaultRoleItem = [
  {
    roleID: "",
    roleName: getLangTxt("pleaseSelectRole")
  },
]

const listData = reactive({
  signList: [],
  mapList: [],
  lotteryList: [],
  exchangeList: [],
  taskList: [],
})

const canClickRefresh = ref(true)

const getCurLink = (link) => {
  let addParams = {
    gameId: pageData.gameId,
    scid: pageData.pageId,
    cid: "activity",
    language: curLang
  }
  return utils.updateLinkParams(link, addParams)
}

// 禁止/允许背景页面滚动
let scrollPosition = 0;

// 弹窗禁止页面滑动
watch(
  () => pageData.multiAwardPopupState,
  (newValue) => {
    const appElement = document.getElementById('app');
    if (newValue) {
      scrollPosition = window.scrollY
      appElement.style.position = 'fixed';
      appElement.style.top = `-${scrollPosition}px`;
    } else {
      appElement.style.position = '';
      appElement.style.top = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollPosition);
    }
  }
)

const resetData = () => {
  pageData.previewPopup = '';
  pageData.isEdit = false;
  pageData.isLogin = false
  pageData.loginAccount = ""
  pageData.isBind = false
  pageData.serverName = ""
  pageData.roleName = ""
  pageData.signTime = 0
  pageData.lotteryTime = 0
  pageData.couponCount = 0
  pageData.currency = ""
  pageData.money = ""
  pageData.infoPopupState = false
  pageData.bindPopupState = false
  pageData.bagPopupState = false
  pageData.tipsPopupState = false
  pageData.propsPopupState = false
  pageData.quanPopupState = false
  pageData.giftCodePopupState = false
  pageData.giftCardPopupState = false
  pageData.thanksPopupState = false
  pageData.multiAwardPopupState = false
  pageData.taskAwardToast = false
  pageData.multiAwardIconList = []
  pageData.isAllowLottery = true
  pageData.giftCardNumber = ''
  pageData.giftCardPassword = ''
  pageData.firstPayType = "sendVt"
  pageData.firstPayState = 0
  pageData.activityType = ''
  pageData.isBrandType = false
  pageData.myPackageList = []
  pageData.curGiftPic = ""
  pageData.curGiftName = ""
  pageData.tips = ""
  pageData.serverList = []
  pageData.recentServerList = []
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  pageData.selectServerIndex = 0
  pageData.selectRoleIndex = 0
  pageData.payEnough = false
  pageData.quanUseLink = getCurLink(pageData.quanUseLink);
  pageData.storeLink = utils.getStoreLinkWithCidScid({
    link: pageData.storeLink,
    paramsObj: {
      language: curLang,
      gameId: pageData.gameId,
    },
    pageId: pageData.pageId,
  });
  pageData.exchangeLink = getCurLink(pageData.exchangeLink);
}

const init = async () => {
  let loginState = await getUserJson()
  if (loginState) {
    window.activityDataLayer.push({
      eventName: "login",
      loginAccount: pageData.loginAccount,
      uid: pageData.uid,
      gameId: pageData.gameId,
      aid: pageData.pageId,
    })
  }
  initActivity()
  pageData.inGame = bridge.runInsdk();
}

const getUserJson = async () => {
  let res = await request.getJSON(utils.getUserJsonApi(pagePlatform))
  if (res.result == 1) {
    pageData.loginAccount = res.data.LOGIN_ACCOUNT
    pageData.isLogin = true
    pageData.uid = res.data.UID || res.data.USER_ID
  }
  return res && res.result == 1
}

const initActivity = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'getConfig'), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res.result == 1) {
    if (res.data.bind_data.role_id) {
      pageData.roleName = res.data.bind_data.role_name
      pageData.serverName = res.data.bind_data.server_name
      pageData.isBind = true
      try {
        window.__updatePointUploadCookie(
          "role_id",
          res.data.bind_data.role_id
        )
        window.__updatePointUploadCookie(
          "role_name",
          res.data.bind_data.role_name
        )
        window.__updatePointUploadCookie(
          "server_id",
          res.data.bind_data.server_id
        )
      } catch (error) {}
    }
    pageData.canReBind = !!+res.data?.switch_role
    pageData.lotteryTime = res.data.lottery_exchange_times
    pageData.couponCount = res.data.lottery_ticket
    pageData.lotteryType = res.data.lottery_type
    try {
      let _money = +res.data.pay_total_next_need
      pageData.payEnough = _money == 0
      pageData.money = `${_money.toLocaleString(curLang)}${
        res.data.area_currency
      }`
    } catch (error) {
      pageData.money = +res.data.pay_total_next_need + res.data.area_currency
    }
    pageData.signTime = res.data.sign_total || 0
    pageData.firstPayType = res.data.first_pay.send_type
    pageData.firstPayState = res.data.first_pay.send_status
    pageData.activityType = res.data.activity_type
    pageData.isAllowLottery = res.data.allow_lottery_show
    pageData.isBrandType = res.data.activity_type === 'brand'
    listData.signList = res.data.sign_award_list
    listData.mapList = res.data.pay_total_list
    listData.lotteryList = res.data.lottery_list
    listData.exchangeList = res.data.exchange_list
    listData.taskList = res.data.active_task_list
    pageData.taskAwardList = res.data.task_award_list_v2 || [];
    pageData.initFinished = true;
    pageData.isActivityEnd = res.data.activity_is_end == 1;
  }
}

watch(
  async () => pageData.bagPopupState,
    (value) => {
      if (!value) return
      getPackageList()
    }
)

const getPackageList = async () => {
  pageData.myPackageList = []
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'listAward'), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res.result == 1) {
    let curBagData = res.data?.reverse() || [];
    curBagData.forEach((item) => {
      if (item.award_block == 'taskListAward') {
        const awardIndex = giftInfo.taskListAward.findIndex(
          (award) => award.realTaskKey == item.send_id
        );
        if (awardIndex != -1) {
          item.send_id = awardIndex + 1;
        }
      }
    });
    pageData.myPackageList.push(...curBagData)
  }
}

resetData()

const checkIsLogin = () => {
  if (pageData.isLogin) return true
  window.location.href = utils.getLoginUrlApi(pagePlatform, pageData.gameId)
  return false
}

const checkIsBind = () => {
  if (pageData.isBind) return true
  pageData.bindPopupState = true
  return false
}

const showTips = (txt, code) => {
  pageData.tips = `${txt} ${code ? `[${code}]` : ""}`
  pageData.tipsPopupState = true
}

const showGetSucc = (type, pic, name) => {
  if (type == "sendVt") {
    pageData.propsPopupState = true
  } else if (type == "sendSerial") {
    pageData.giftCodePopupState = true
  } else if (type == "sendEGift") {
    pageData.giftCardPopupState = true
  } else if (type == "sendNothing") {
    pageData.thanksPopupState = true
  } else {
    pageData.quanPopupState = true
  }
  pageData.curGiftPic = pic
  pageData.curGiftName = name
}

const appFn = {
  // 打开新页面
  openNewPage(url) {
    if (!url?.trim()) return;
    const bool = bridge.runInsdk();

    url = utils.getStoreLinkWithCidScid({
      link: url, // 页面储值链接，传为空则函数返回为空
      paramsObj: {
        // 需要带上的参数，如果要自定义cid、scid这里传入会覆盖默认的cid、scid处理
        language: curLang,
        gameId: pageData.gameId,
      },
      pageId: pageData.pageId, // 活动标识
    });
    bridge.open(url);
  },
  // 根据当前页面域名替换输入的链接域名
  replaceDomainToCurPageDomain(link) {
    // 获取当前页面的二级域名
    const currentDomain = window.location.hostname
      .split('.')
      .slice(-2)
      .join('.');

    const newLink = utils.getStoreLinkWithCidScid({
      link: link,
      paramsObj: {
        language: curLang,
        gameId: pageData.gameId,
      },
      pageId: pageData.pageId,
    });

    const url = new URL(newLink);

    // 将链接的二级域名替换成当前页面的二级域名
    const domain = url.hostname.split('.').slice(-2).join('.');
    const newUrl = url.toString().replace(domain, currentDomain);

    return newUrl;
  },
  async share() {
    pageData.shareFactoryInst.showPopup();
  },
};

const api = {
  // 分享回调
  async shareCallback(shareRes, shareType, shareMsg) {
    await request.getJSON(
      utils.getActivityApi(pagePlatform, pageData.pageId, 'shareCallback'), {
        params: JSON.stringify({
          shareRes,
          shareType,
          shareMsg,
        }),
      }
    );
    return Promise.resolve();
  },
};

provide("checkIsLogin", checkIsLogin)
provide("checkIsBind", checkIsBind)
provide("listData", listData)
provide("initActivity", initActivity)
provide("canClickRefresh", canClickRefresh)
provide("showTips", showTips)
provide("showGetSucc", showGetSucc)
provide("init", init)
provide("giftInfo", giftInfo)
provide("getCurLink", getCurLink)
provide('appFn', appFn);
provide('api', api);
      // 自定义setup - 结束


  </script>
  <style lang="scss">
    @import 'assets/common.scss';

    .btn-light:hover {
  filter: brightness(1.2);
  cursor: pointer;
}

html,
body {
  height: auto !important;
  width: 100%;
}

[dir=rtl] .rtl-trans {
  transform: scaleX(-1);
}

.swiper-button-disabled {
  display: none;
}

.zoom-in {
  animation: zoomIn;
  animation-duration: 0.8s;
}

.swing {
  animation: swing ease-in-out 0.8s infinite;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
  </style>
  